module.exports = __webpack_public_path__ + "media/images/avatar/5-87887d10bbd4bbd6c02b335e9a75afc2.svg";